module.exports = __webpack_public_path__ + "static/sport/bgi-btn.91482b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/bgi-btn.png
// module id = /xku
// module chunks = 0